/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_DescriptionInputs */

const en_visa_eb2niw_description = /** @type {(inputs: Visa_Eb2niw_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The EB-2 NIW allows certain applicants to request a waiver of the usual job-offer and labor-certification requirements when the proposed work can be shown to have substantial merit and national importance to the United States.`)
};

const pt_visa_eb2niw_description = /** @type {(inputs: Visa_Eb2niw_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O EB-2 NIW permite que certos solicitantes peçam a dispensa dos requisitos usuais de oferta de emprego e certificação trabalhista quando o trabalho proposto puder demonstrar mérito substancial e importância nacional para os Estados Unidos.`)
};

const es_visa_eb2niw_description = /** @type {(inputs: Visa_Eb2niw_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El EB-2 NIW permite que ciertos solicitantes pidan la exención de los requisitos habituales de oferta de trabajo y certificación laboral cuando el trabajo propuesto pueda demostrar mérito sustancial e importancia nacional para los Estados Unidos.`)
};

/**
* | output |
* | --- |
* | "The EB-2 NIW allows certain applicants to request a waiver of the usual job-offer and labor-certification requirements when the proposed work can be shown to..." |
*
* @param {Visa_Eb2niw_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_description = /** @type {((inputs?: Visa_Eb2niw_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_description(inputs)
	if (locale === "es") return es_visa_eb2niw_description(inputs)
	return en_visa_eb2niw_description(inputs)
});